import styled from "styled-components";

export const ShiftStartHour = styled.div`
    font-size: 14px;
    font-weight: bold;
`;

export const ShiftEndHour = styled.div`
    font-size: 12px;
`;

export const DateLabel = styled.div`
    font-size: 14px;
    font-weight: bold;
`;
